<template>
  <div class="page-btns-father">
    <div class="page-btns-main">
      <div class="common-title">发票上传</div>
      <div class="page-main common no-shadow common-form-inline">
        <a-form-model :rules="ruleForm" ref="ruleForm" :model="pageData" :label-col="{ span: 6 }"
          :wrapper-col="{ span: 13 }">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="买方名称">
                <div style="white-space: nowrap;">
                  <span>{{ pageData.buryName }}</span><span style="margin-left:16px;">{{
                    pageData.buryOrgCode
                  }}</span>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="发票上传" prop="tblBlId" style="margin-bottom:10px">
                <imgUpload style="height:120px;" @remove="removeOk" :file="fileList" :paramObj="uploadParam"
                  @uploadOk="uploadOk" name="file"></imgUpload>
                <div class="text-color-orange img-tip">
                  温馨提示：请核对系统读取的票面要素信息，如有错误，请务必修改。若无法读取，请上传清晰票面或手工输入。发票票面需含有发票专用章。
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="发票类型" prop="invoiceType">
                <a-select v-model="pageData.invoiceType" :allowClear="true" style="width:100%" :disabled="formDisabled"
                  placeholder="请选择" @change="invTypeChange">
                  <a-select-option v-for="item in invoiceTypes" :key="item.dctVal" :value="item.dctVal"
                    :label="item.dctValNm">{{ item.dctValNm }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item v-if="pageData.invoiceType == 4" label="发票代码">
                <a-input v-model="pageData.invoiceCode" placeholder="请输入" :disabled="true" />
              </a-form-model-item>
              <a-form-model-item v-else label="发票代码" prop="invoiceCode">
                <a-input v-model="pageData.invoiceCode" placeholder="请输入" :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="发票号码" prop="invoiceNumber">
                <a-input v-model="pageData.invoiceNumber" placeholder="请输入" :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="开票日期" prop="billTime">
                <a-date-picker v-model="pageData.billTime" placeholder="请输入" :disabled="formDisabled"
                  valueFormat="YYYY-MM-DD" style="width:100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="pageData.invoiceType == 2 || pageData.invoiceType == 3">
              <a-form-model-item label="发票校验码后六位" prop="checkCode">
                <a-input v-model="pageData.checkCode" placeholder="请输入" :disabled="formDisabled" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="pageData.invoiceType == 0 || pageData.invoiceType == 1">
              <a-form-model-item label="发票金额" prop="invoiceAmount">
                <a-input v-model="pageData.invoiceAmount" placeholder="请输入" type="number" :disabled="formDisabled"
                  suffix="(不含税)元" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="发票金额" prop="invoiceAmountWithVat">
                <a-input v-model="pageData.invoiceAmountWithVat" placeholder="请输入" type="number" suffix="(含税)元" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <div class="spaceCenter" style="margin:24px 0 0 0;">
          <a-button class="btn-blue-line" @click="resetForm" style="margin-right:10px;">重置</a-button>
          <button-load @clickHandle="importTable" type="primary" lable="导入列表" />
        </div>
      </div>

      <div class="common-title">发票列表</div>
      <div class="table-common common">
        <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
          :loading="loading" bordered :locale="{ emptyText: '暂无数据' }">
          <template slot="invoiceType" slot-scope="text">
            {{ text | invoiceTypeFilter }}
          </template>
          <template slot="invoiceCode" slot-scope="text,record">
            {{
              +record.invoiceType === 4 ? "--" : text
            }}
          </template>
          <template slot="invoiceAmountWithVat" slot-scope="text">
            {{ text | splitK }}
          </template>
          <template slot="invoiceAmount" slot-scope="text">
            {{ text | splitK }}
          </template>
          <template slot="checkCode" slot-scope="text, record">
            {{
              +record.invoiceType === 0 || +record.invoiceType === 1
              ? "--"
              : text
            }}
          </template>
          <template slot="oper" slot-scope="text, record, index">
            <a @click="toInvInfo(record)">查看</a>
            <a @click="toRevoke(record, index)" class="text-color-orange">撤销</a>
          </template>
        </a-table>
        <div class="text-color-orange" style="margin-top:10px;">
          温馨提示：若列表中含融资已使用的发票，请务必撤销。
        </div>
      </div>
    </div>
    <div class="spaceCenter page-bottom-btns">
      <a-button class="btn-blue-line" @click="goBack()" style="margin:0 5px;">取消</a-button>
      <button-load @clickHandle="gotoCheck" type="primary" lable="去查验" />
    </div>

    <!-- 发票详情 -->
    <invoiceInfo ref="invoiceInfo" :info.sync="curRow" :readonly="true" />

    <!-- 查验结果弹窗 -->
    <receivableImportReslut ref="receivableImportReslut" />
  </div>
</template>

<script>
import invoiceInfo from "./invoice-info-dialog.vue";
import receivableImportReslut from "./receivable-import-reslut.vue";
import imgUpload from "@/components/ui/img-upload/img-upload";
import {
  getQRCodeInfo,
  invoiceSave,
  updateById,
  invoiceList,
  invDelete,
  go2Check
} from "@/api/payable.js";
import { fileSaveAPI } from "@/api/file.js";
import { mapActions } from "vuex";
export default {
  name: "payable-import",
  components: {
    invoiceInfo,
    imgUpload,
    receivableImportReslut
  },
  data() {
    return {
      name: "importFile",
      url: "/user/rcvbBuy/import",
      fileList: {},
      uploading: false,
      invoiceTypes: [],
      uploadParam: {
        app: "portal-pc",
        module: "payable",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: "payable"
      },
      pageData: {
        buryName: undefined,
        buryOrgCode: undefined,
        tenanId: undefined,
        invoiceType: undefined,
        billTime: undefined
      },
      ruleForm: {
        tblBlId: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, cbfn) => {
              if (!this.pageData.tblBlId) {
                cbfn("请上传发票");
              } else {
                cbfn();
              }
            }
          }
        ],
        invoiceType: [
          { required: true, message: "发票类型不能为空", trigger: "blur" }
        ],
        invoiceCode: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("发票代码不能为空");
              } else if (
                value.length != 12 &&
                (this.pageData.invoiceType == 2 ||
                  this.pageData.invoiceType == 3)
              ) {
                cbfn("发票代码需为12位数字");
              } else if (
                value.length != 10 &&
                (+this.pageData.invoiceType === 0 ||
                  +this.pageData.invoiceType === 1)
              ) {
                cbfn("发票代码需为10位数字");
              } else {
                cbfn();
              }
            }
          }
        ],
        invoiceNumber: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("发票号码不能为空");
              } else if (value.length != 8 &&
                (this.pageData.invoiceType == 0 || this.pageData.invoiceType == 1 || this.pageData.invoiceType == 2 ||
                  this.pageData.invoiceType == 3)) {
                cbfn("发票号码需为8位数字");
              } else if (value.length != 20 &&
                (this.pageData.invoiceType == 4)) {
                cbfn("发票号码需为20位数字");
              }
              else {
                cbfn();
              }
            }
          }
        ],
        billTime: [
          { required: true, message: "开票日期不能为空", trigger: "change" }
        ],
        invoiceAmountWithVat: [
          {
            required: true,
            message: "发票金额（含税）不能为空",
            trigger: "blur"
          }
        ],
        invoiceAmount: [
          {
            required: true,
            message: "发票金额（不含税）不能为空",
            trigger: "blur"
          }
        ],
        checkCode: [
          {
            required: true,
            message: "发票校验码后六位不能为空",
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      curRow: null,
      loading: false,
      columns: [
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" }
        },
        {
          title: "发票代码",
          dataIndex: "invoiceCode",
          scopedSlots: { customRender: "invoiceCode" }
        },
        {
          title: "发票号码",
          dataIndex: "invoiceNumber"
        },
        {
          title: "开票日期",
          dataIndex: "billTime"
        },
        {
          title: "发票金额（不含税）",
          dataIndex: "invoiceAmount",
          scopedSlots: { customRender: "invoiceAmount" }
        },
        {
          title: "验证码后六位",
          dataIndex: "checkCode",
          scopedSlots: { customRender: "checkCode" }
        },
        {
          title: "发票金额（含税）",
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" }
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" }
        }
      ],
      formDisabled: false,
      noRenderItem: ["tenanId", "buryName", "buryOrgCode"] //不能OCR识别覆盖的字段
    };
  },
  created() {
    this.initPage();
    this.getDicAsync("InvoiceType").then(res => {
      this.invoiceTypes = res;
    });
  },
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    initPage() {
      this.pageData.buryName = this.$route.query.buryName;
      this.pageData.buryOrgCode = this.$route.query.buryOrgCode;
      this.pageData.tenanId = this.$route.query.tenanId;
      this.getInvoiceList();
    },
    invTypeChange(val) {
      if (+val === 0 || +val === 1) {
        //专票
        this.ruleForm.checkCode = {};
        this.ruleForm.invoiceAmount = [
          {
            required: true,
            message: "发票金额（不含税）不能为空",
            trigger: "blur"
          }
        ];
      } else if (+val === 2 || +val === 3) {
        // this.ruleForm.invoiceAmount = {};
        this.ruleForm.checkCode = [
          {
            required: true,
            message: "发票校验码后六位不能为空",
            trigger: "blur"
          }
        ];
      }
      if (this.pageData.invoiceType == 4) {
        this.pageData.invoiceCode = ''
      }
    },
    // 删除文件
    removeOk() {
      this.fileList = null;
      this.pageData.tblBlId = "";
      this.$refs.ruleForm && this.$refs.ruleForm.validateField("tblBlId");
    },
    getQRCodeInfo(fileId) {
      let self = this;
      getQRCodeInfo({ fileId: fileId }, true)
        .then(res => {
          self.formDisabled = false;
          this.uploading = false;
          if (!res.data) {
            this.$confirm({
              title: "发票OCR识别失败",
              content: "请上传清晰发票影像或手工输入发票信息",
              onOk() { },
              onCancel() { }
            });
            return;
          }
          let resData = res.data || {};
          for (let k in resData) {
            if (this.noRenderItem.indexOf(k) == -1) {
              this.$set(this.pageData, k, resData[k]);
            }
          }
        })
        .catch(err => {
          this.uploading = false;
          this.$confirm({
            title: "发票OCR识别失败",
            content: "请上传清晰发票影像或手工输入发票信息",
            onOk() { },
            onCancel() { }
          });
        });
    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: "payable",
        useCase: "supplier"
      };
      fileSaveAPI(param)
        .then(res => {
          this.fileList = data;
          this.pageData.fileId = res.data.fileId;
          this.pageData.tblBlId = this.uploadParam.tblBlId;
          this.getQRCodeInfo(this.pageData.fileId);
          this.$refs.ruleForm && this.$refs.ruleForm.validateField("tblBlId");
        })
        .catch(err => {
          this.uploading = false;
        });
    },
    uploadOk(resList) {
      this.fileSave(resList[0]);
    },
    // 导入列表
    importTable(btn) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.pageData.tblBlId = this.uploadParam.tblBlId;
          this.pageData.invoiceId = this.pageData.fileId;
          this.pageData.docTpCd = "2";
          this.pageData.useCase = "supplier";
          invoiceSave(this.pageData)
            .then(res => {
              this.$message.success("导入列表成功");
              btn && btn.closeLoad();
              this.getInvoiceList();
              this.resetForm();
            })
            .catch(err => {
              btn && btn.closeLoad();
            });
        } else {
          btn && btn.closeLoad();
        }
      });
    },
    // 查询该买方下未查验的单据列表
    getInvoiceList() {
      this.loading = true;
      let param = {
        buryOrgCode: this.pageData.buryOrgCode,
        resultCode: 3,
        useCase: "supplier"
      };
      invoiceList(param)
        .then(res => {
          this.loading = false;
          this.tableData = res.data.grid.list || [];
        })
        .catch(err => {
          this.loading = false;
        });
    },
    gotoCheck(btn) {
      let params = {
        cyCodeList: this.tableData.map(i => i.cyCode)
      };
      go2Check(params)
        .then(res => {
          this.$message.success("操作成功");
          // this.goBack();
          btn.closeLoad();
          this.$refs.receivableImportReslut.open(res.data);
        })
        .catch(err => {
          btn.closeLoad();
        });
    },
    resetForm() {
      this.pageData = {
        buryName: this.$route.query.buryName,
        buryOrgCode: this.$route.query.buryOrgCode,
        tenanId: this.$route.query.tenanId
      };
      this.fileList = null;
      this.$refs.ruleForm.resetFields();
    },
    // 查看发票信息
    toInvInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    toRevoke(record, index) {
      let self = this;
      this.$confirm({
        title: "撤销",
        content: "是否撤销所勾选的应付账款？",
        onOk() {
          const params = {
            ids: record.id
          };
          invDelete(params).then(res => {
            self.$message.success("撤销成功");
            self.tableData.splice(index, 1);
          });
        },
        onCancel() { }
      });
    },
    goBack() {
      this.MENUAPI.goToOneTab({
        path: "bill-manage/receivable"
      });
    }
  },
  watch: {
    "pageData.invoiceType"(newVal) {
      this.invTypeChange(newVal);
    }
  }
};
</script>
<style scoped lang="less">
.ant-input-affix-wrapper /deep/ .ant-input:not(:last-child) {
  padding-right: 64px !important;
}

.file-item {
  background: #e5e7e8;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  width: 240px;
  margin: 0 10px;
}

.img-tip {
  margin-top: -20px;
  white-space: nowrap;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/receivable/receivable-import.vue